import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export const maxCharactersString = (string: string, maxCharacters: number) => {
  if (string.length > maxCharacters) {
    return `${string.substring(0, maxCharacters)}...`;
  }
  return string;
};

export function isFetchBaseQueryError(
  error: any
): error is FetchBaseQueryError {
  return typeof error === 'object' && error !== null && 'data' in error;
}

export const alphaNumericCompare = (a: string, b: string) => {
  return a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: 'base'
  });
};
